import { render } from "./DrillCard.vue?vue&type=template&id=0165423d&scoped=true"
import script from "./DrillCard.vue?vue&type=script&lang=js"
export * from "./DrillCard.vue?vue&type=script&lang=js"

import "./DrillCard.vue?vue&type=style&index=0&id=0165423d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0165423d"]])

export default __exports__